interface SectionHeadingProps {
  eyebrow?: string;
  title: string;
  description?: string;
  align?: "left" | "center";
  id?: string;
}

export default function SectionHeading({
  eyebrow,
  title,
  description,
  align = "left",
  id,
}: SectionHeadingProps) {
  const isCenter = align === "center";
  return (
    <div
      id={id}
      className={`max-w-2xl ${isCenter ? "mx-auto text-center" : ""}`}
    >
      {eyebrow ? (
        <div
          className={`mb-3 flex items-center gap-2 text-xs font-medium tracking-[0.28em] text-primary-600 ${
            isCenter ? "justify-center" : ""
          }`}
        >
          <span className="h-px w-6 bg-primary-400" />
          {eyebrow}
        </div>
      ) : null}
      <h2 className="font-heading text-2xl font-bold leading-snug text-foreground-950 md:text-3xl">
        {title}
      </h2>
      {description ? (
        <p className="mt-3 text-sm leading-relaxed text-foreground-600 md:text-base">
          {description}
        </p>
      ) : null}
    </div>
  );
}